import { all, call } from 'redux-saga/effects';

import admin from './admin.saga';

function* rootSaga() {
  yield all([call(admin)]);
}

export default rootSaga;
